export enum CompleteProcedureType{
    Standard,
    LeakTest,
    PressureTest,
    PressureSet
}